export type ParameterType = 'string' | 'boolean' | 'number';

export interface Parameter {
  id: string;
  key: string;
  value: string;
  type: ParameterType;
  description: string | null;
  community_id: string | null;
}

export interface ParsedParameter {
  value: string | boolean | number;
  type: ParameterType;
}

export interface Parameters {
  [key: string]: ParsedParameter;
}

export const parseParameterValue = (value: string, type: ParameterType): string | boolean | number => {
  switch (type) {
    case 'boolean':
      return value.toLowerCase() === 'true';
    case 'number':
      const num = Number(value);
      return isNaN(num) ? 0 : num;
    default:
      return value;
  }
};